import Vue from 'vue'
import api from '@/modules/apies/api'
// axios
import axios from 'axios'

// در پروداکشن پنل و API روی یک دامنه (core.etarkhis.com) هستند، پس آدرس نسبی استفاده می‌شود
const baseURL = process.env.NODE_ENV === 'production' ? '/api/' : 'https://localhost:7065/api/'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})
const makeToast = function (title, variant, toaster, text) {
  const vm = new Vue()
  vm.$bvToast.toast(text, {
    title,
    toaster,
    variant,
    solid: false,
    appendToast: true,
  })
}

axiosIns.interceptors.response.use(res => {
  if (res.data.Message) {
    makeToast('عملیات موفق', 'success', 'b-toaster-bottom-right', res.data.Message)
  }
  return Promise.resolve({
    data: res.data.Data,
    message: res.data.Message,
    totalRow: res.data.TotalRow,
  })
}, err => {
  if (err.request.status === 401) {
    localStorage.removeItem('userData')
    window.location.reload()
  } else if (err.response.data.Message) {
    err.response.data.Message.split(';')
      .forEach(item => {
        makeToast('خطا در انجام عملیات', 'danger', 'b-toaster-bottom-right', item)
      })
  }

  return Promise.reject(err)
})
Vue.prototype.$http = axiosIns
Vue.prototype.$api = api
export default axiosIns
